import React from 'react'
import {useTranslation} from '@modifi/plugin-i18n'
import {Row, Col, H6} from '@modifi/ui'
import {
  AddressForm,
  FormInputRow,
  NumberFormatInputComponent,
  INTERMEDIARY_SHAREHOLDER_VOTING_SHARE,
  COMPANY_INTERMEDIARY_SHAREHOLDERS,
} from '@modifi/plugin-onboarding'

import {ExampleImageContainer, StyledImg} from './styles'

type IntermediaryShareHoldersFormContentProps = {
  canUpdateCompany?: boolean
}

const IntermediaryShareHoldersFormContent: React.FC<IntermediaryShareHoldersFormContentProps> = ({
  canUpdateCompany = true,
}) => {
  const {t} = useTranslation(['charon', 'plugin-forms'])

  return (
    <>
      <FormInputRow
        t={t}
        inputName={INTERMEDIARY_SHAREHOLDER_VOTING_SHARE}
        inputComponent={NumberFormatInputComponent}
        inputProps={{
          decimalSeparator: '.',
          decimalScale: 2,
          fixedDecimalScale: true,
          suffix: '%',
          label: t('intermediary-shareholders-page.voting-share.label'),
          placeholder: t('form-field.input-percentage.default-placeholder', {ns: 'plugin-forms'}),
        }}
        lg={12}
      />
      <AddressForm formType={COMPANY_INTERMEDIARY_SHAREHOLDERS} isReadOnly={!canUpdateCompany} />
      <Row mb={16}>
        <Col>
          <H6>{t('intermediary-shareholders-page.example-diagram.headline')}</H6>
        </Col>
      </Row>

      <Row mb={40}>
        <Col>
          <ExampleImageContainer>
            <StyledImg
              src="/assets/images/intermediary-shareholder-chart.png"
              alt="intermediary-shareholders-sample-chart"
            />
          </ExampleImageContainer>
        </Col>
      </Row>
    </>
  )
}

export default IntermediaryShareHoldersFormContent
